/** Copyright (c) 2018 T.Rowe Price. All rights reserved. */

export const REQUESTED_ACCOUNTS = 'REQUESTED_ACCOUNTS';
export const requestedAccounts = () => {
  return {
    type: REQUESTED_ACCOUNTS
  };
};

export const RECEIVED_ACCOUNTS = 'RECEIVED_ACCOUNTS';

export const receivedAccounts = (accounts, rpsAccounts = []) => ({
  type: RECEIVED_ACCOUNTS,
  accounts,
  rpsAccounts
});

export const ERROR_ACCOUNTS = 'ERROR_ACCOUNTS';
export const errorAccounts = (error) => ({
  type: ERROR_ACCOUNTS,
  error
});

export const ACCOUNT_RESTRICTION = 'ACCOUNT_RESTRICTION';
export const accountRestriction = (error) => ({
  type: ACCOUNT_RESTRICTION,
  error
});

export const REQUESTED_PURGED_ACCOUNTS = 'REQUESTED_PURGED_ACCOUNTS';
export const requestedPurgedAccounts = () => {
  return {
    type: REQUESTED_PURGED_ACCOUNTS
  };
};

export const RECEIVED_PURGED_ACCOUNTS = 'RECEIVED_PURGED_ACCOUNTS';
export const receivedPurgedAccounts = (purgedAccounts = []) => ({
  type: RECEIVED_PURGED_ACCOUNTS,
  purgedAccounts
});

export const ERROR_PURGED_ACCOUNTS = 'ERROR_PURGED_ACCOUNTS';
export const errorPurgedAccounts = (error) => ({
  type: ERROR_PURGED_ACCOUNTS,
  error
});
